import React from 'react';

const Inventory = () => {
    return (
        <div>
            <h1 style={{ textAlign: 'center', }}>Developer is sleeping...😴</h1>
        </div>
    );
};

export default Inventory;